import ConsultationEventListener from './ConsultationEventListener';

export default ConsultationEventListener;
